/* Direct theme trackers only. Shopify app pixels and backend delivery are separate. */
(function () {
  'use strict';
  if (window.AlphardPrivacy) return;
  var configNode = document.getElementById('alphard-analytics-config');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent);
  var privacyReady = false;
  var previous = null;
  var revision = 0;
  var marketingStarted = false;
  var marketingPending = false;
  var pageViewSent = false;
  var productViewSent = false;
  var sdkReady = false;
  var sdkInitialized = false;
  var cartWork = Promise.resolve();
  var cartKnown = config.cartItemCount > 0 || config.cartHasTracking === true;
  var adCookies = ['gclid', 'gbraid', 'wbraid', 'fbclid', '_fbc', 'campaign_id',
    'ad_account_id', 'analytics_client_id', 'utm_source', 'utm_medium',
    'utm_campaign', 'utm_term', 'utm_content'];
  var cartKeys = ['fbp', 'fbc', 'fbclid', 'gclid', 'ga_client_id', 'analytics_visitor_id'];

  function permissions() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacyReady || !api) return { analytics: false, advertising: false };
    try {
      return {
        analytics: api.analyticsProcessingAllowed() === true,
        advertising: api.marketingAllowed() === true && api.saleOfDataAllowed() === true
      };
    } catch (error) {
      return { analytics: false, advertising: false };
    }
  }

  function cookie(name) {
    var prefix = name + '=';
    var entry = document.cookie.split(';').map(function (part) { return part.trim(); })
      .find(function (part) { return part.indexOf(prefix) === 0; });
    if (!entry) return '';
    try { return decodeURIComponent(entry.slice(prefix.length)); }
    catch (error) { return entry.slice(prefix.length); }
  }

  function writeCookie(name, value) {
    document.cookie = name + '=' + value + '; Max-Age=7776000; Path=/; SameSite=Lax; Secure';
  }

  function expireCookie(name) {
    // Cover host-only and domain cookies created by previous tracker versions.
    var domains = ['', window.location.hostname, '.' + window.location.hostname];
    var parts = window.location.hostname.split('.');
    if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
    domains.forEach(function (domain) {
      document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' +
        (domain ? '; Domain=' + domain : '');
    });
  }

  function visitorId() {
    if (!permissions().analytics) return '';
    var id = cookie('_ap_vid');
    if (!id) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      id = 'uuid:' + Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      writeCookie('_ap_vid', id);
    }
    return id;
  }

  function captureAdvertising() {
    if (!permissions().advertising) return;
    var query = new URLSearchParams(window.location.search);
    var campaign = query.get('campaign_id') || query.get('utm_id') || query.get('gad_campaignid');
    var freshCampaign = campaign || ['source', 'medium', 'campaign', 'term', 'content']
      .some(function (key) { return query.has('utm_' + key); });
    adCookies.filter(function (name) { return name !== '_fbc'; }).forEach(function (name) {
      var value = name === 'campaign_id' ? campaign : query.get(name);
      if (value) writeCookie(name, encodeURIComponent(value));
      else if (freshCampaign && /^(utm_|campaign_id|ad_account_id|analytics_client_id)/.test(name)) expireCookie(name);
    });
    var fbclid = query.get('fbclid');
    if (fbclid) writeCookie('_fbc', 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + encodeURIComponent(fbclid));
  }

  function cleanUrl(value, advertising) {
    if (advertising) return value;
    try {
      var url = new URL(value);
      return url.origin + url.pathname;
    } catch (error) { return ''; }
  }

  function trackEvent(name, data) {
    var allowed = permissions();
    if (!allowed.analytics) return;
    data = data || {};
    var ga = allowed.advertising ? cookie('_ga').split('.').slice(2).join('.') : '';
    var utm = {};
    if (allowed.advertising) {
      ['source', 'medium', 'campaign', 'term', 'content'].forEach(function (key) {
        var value = cookie('utm_' + key);
        if (value) utm[key] = value;
      });
      ['campaign_id', 'ad_account_id', 'analytics_client_id'].forEach(function (key) {
        if (cookie(key)) utm[key] = cookie(key);
      });
    }
    var payload = {
      event_name: name, event_time: Math.floor(Date.now() / 1000),
      event_id: data.event_id || 'evt_' + Date.now() + '_' + Math.random().toString(36).slice(2),
      value: data.value || 0, currency: data.currency || config.currency,
      order_id: data.order_id || null, visitor_id: visitorId(),
      ga: ga ? { client_id: ga } : null,
      google_ads: allowed.advertising ? {
        gclid: cookie('gclid'), gbraid: cookie('gbraid'), wbraid: cookie('wbraid')
      } : null,
      meta: allowed.advertising ? {
        fbclid: cookie('fbclid'), _fbc: cookie('_fbc'), _fbp: cookie('_fbp'),
        content_ids: data.content_ids || [], content_name: data.content_name || '',
        num_items: data.num_items || (data.content_ids || []).length
      } : null,
      utm: Object.keys(utm).length ? utm : null,
      user: { client_user_agent: navigator.userAgent },
      page: {
        event_source_url: cleanUrl(window.location.href, allowed.advertising),
        referrer: cleanUrl(document.referrer, allowed.advertising)
      }
    };
    fetch(config.backendUrl, {
      method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function (error) { console.error('Alphard analytics:', error); });
  }

  function syncCart() {
    // Do not create an empty cart token concurrently with the first add.
    // A late cart response can otherwise replace the token of the populated cart.
    if (!cartKnown) return Promise.resolve();
    var currentRevision = revision;
    cartWork = cartWork.catch(function () {}).then(function () {
      if (currentRevision !== revision) return;
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      }).then(function (cart) {
        if (currentRevision !== revision) return;
        var allowed = permissions();
        var ga = allowed.advertising ? cookie('_ga').split('.').slice(2).join('.') : '';
        var desired = {
          fbp: allowed.advertising ? cookie('_fbp') : '',
          fbc: allowed.advertising ? cookie('_fbc') : '',
          fbclid: allowed.advertising ? cookie('fbclid') : '',
          gclid: allowed.advertising ? cookie('gclid') : '',
          ga_client_id: ga,
          analytics_visitor_id: allowed.analytics ? visitorId() : ''
        };
        var changes = {};
        cartKeys.forEach(function (key) {
          if (((cart.attributes || {})[key] || '') !== desired[key]) changes[key] = desired[key];
        });
        if (!Object.keys(changes).length) return;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: changes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart attribution update failed');
        });
      });
    }).catch(function (error) { console.error('Alphard attribution:', error); });
    return cartWork;
  }

  function measure(name, data) {
    if (sdkReady && permissions().advertising && window.oaiq) window.oaiq('measure', name, data);
  }

  function productView() {
    var node = document.querySelector('[data-alphard-product-event]');
    if (!productViewSent && node && sdkReady && permissions().advertising && window.oaiq) {
      measure('contents_viewed', JSON.parse(node.textContent));
      productViewSent = true;
    }
  }

  function loadMarketing() {
    if (!permissions().advertising || marketingStarted || marketingPending) return;
    marketingPending = true;
    var sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = config.oaiqUrl;
    sdk.onload = function () {
      marketingPending = false;
      sdkReady = true;
      updateMarketingConsent();
    };
    sdk.onerror = function () { marketingPending = false; };
    // The SDK expects the standard queue to exist before it loads.
    var queue = function () { queue.q.push(arguments); };
    queue.q = [];
    window.oaiq = queue;
    window.oaiq('consent', false);
    document.head.appendChild(sdk);
    var referral = document.createElement('script');
    referral.src = config.referralUrl;
    referral.setAttribute('data-api-url', config.referralApiUrl);
    referral.setAttribute('data-api-key', config.referralKey);
    document.head.appendChild(referral);
    marketingStarted = true;
  }

  function updateMarketingConsent() {
    if (!window.oaiq) return;
    var allowed = permissions().advertising;
    window.oaiq('consent', allowed);
    if (!allowed || !sdkReady) return;
    if (!sdkInitialized) {
      window.oaiq('init', { pixelId: config.pixelId });
      sdkInitialized = true;
    }
    productView();
  }

  function applyPermissions() {
    var next = permissions();
    if (previous && previous.analytics === next.analytics && previous.advertising === next.advertising) return;
    revision += 1;
    previous = next;
    if (!next.analytics) expireCookie('_ap_vid');
    if (!next.advertising) {
      adCookies.forEach(expireCookie);
      expireCookie('__obref');
      expireCookie('refferq_ref');
    }
    if (next.advertising) captureAdvertising();
    if (next.analytics) {
      visitorId();
      if (!pageViewSent) {
        trackEvent('PageView', { currency: config.currency });
        pageViewSent = true;
      }
    }
    syncCart();
    loadMarketing();
    updateMarketingConsent();
  }

  window.AlphardPrivacy = { permissions: permissions, trackEvent: trackEvent, measure: measure };
  window.AnalyticsTracker = { trackEvent: trackEvent };
  document.addEventListener('visitorConsentCollected', function () {
    privacyReady = true;
    applyPermissions();
  });
  document.addEventListener('theme:cart:added', function () {
    // The theme emits this after a successful add and cart rendering.
    cartKnown = true;
    if (privacyReady) syncCart();
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-alphard-add-to-cart]');
    if (button) {
      var data = {
        value: Number(button.dataset.alphardValue), currency: button.dataset.alphardCurrency,
        content_ids: [button.dataset.alphardVariant]
      };
      trackEvent('add_to_cart', data);
      measure('items_added', {
        type: 'contents', amount: Math.round(data.value * 100), currency: data.currency,
        contents: [{ id: data.content_ids[0], quantity: 1 }]
      });
    }
    if (permissions().advertising && event.target.closest('[name="checkout"], a[href*="/checkout"], [data-checkout], .cart__checkout')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'begin_checkout' });
    }
  }, true);

  var attempts = 0;
  var loading = false;
  function connectPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      privacyReady = true;
      applyPermissions();
      return;
    }
    if (!loading && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && window.Shopify.customerPrivacy) {
          privacyReady = true;
          applyPermissions();
        }
      });
    }
    if (++attempts < 60) setTimeout(connectPrivacy, 250);
  }
  connectPrivacy();
})();
